import { ReactNode } from "react";

import { Classes } from "@blueprintjs/core";
import styled from "@emotion/styled";

import {
  GREEN,
  LIGHT_PURPLE,
  LIGHTEST_BACKGROUND,
  YELLOW,
} from "@/css/constants";

interface TimelineItemProps {
  intent?: string;
  children: ReactNode;
}

function TimelineItemComponent({ intent, children }: TimelineItemProps) {
  let intentClass =
    intent === "success"
      ? Classes.INTENT_SUCCESS
      : intent === "active"
        ? Classes.ACTIVE
        : intent === "canceled"
          ? "intent-canceled"
          : undefined;

  return (
    <StyledTimelineItem className={intentClass}>
      <div className="timeline-line" />
      <div className="timeline-indicator" />
      <div className="timeline-content">{children}</div>
    </StyledTimelineItem>
  );
}

const TimelineComponent = styled("div")`
  position: relative;
`;

const StyledTimelineItem = styled("div")`
  position: relative;
  padding: 0 0 40px 40px;

  &:last-child {
    padding-bottom: 0;

    .timeline-line {
      display: none;
    }
  }
  &.${Classes.ACTIVE} {
    .timeline-line {
      border-left-style: dashed;
    }
    .timeline-indicator {
      background-color: #fff4db;
      border: 4px solid ${YELLOW};
    }
  }
  &.${Classes.INTENT_SUCCESS} {
    .timeline-line {
      border-color: ${GREEN};
    }
    .timeline-indicator {
      background-color: ${GREEN};
      border-color: ${GREEN};
    }
  }
  &.intent-canceled {
    .timeline-line {
      border-left-style: solid;
    }
    .timeline-indicator {
      background-color: ${LIGHT_PURPLE};
    }
  }
  .timeline-content {
    padding-top: 1px;
  }

  .timeline-line {
    position: absolute;
    top: 0;
    left: 9px;
    width: 2px;
    height: 100%;
    border-left: 2px solid ${LIGHT_PURPLE};
  }

  .timeline-indicator {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    position: absolute;
    left: 0;
    background-color: ${LIGHTEST_BACKGROUND};
    border: 4px solid ${LIGHT_PURPLE};
  }
`;

export const Timeline = TimelineComponent;
export const TimelineItem = TimelineItemComponent;
